import { render, staticRenderFns } from "./NationalTrademarkResponsibleList.vue?vue&type=template&id=65c26fc4&"
import script from "./NationalTrademarkResponsibleList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkResponsibleList.vue?vue&type=style&index=0&id=65c26fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports